export const nodeIdentity = node => ({
  id: node.sessionId || node.nodeId || node.id,
  deviceId: node.deviceId || node.nodeId || node.id || node.sessionId
});

export const monitorEventMatches = (node, data) => {
  const eventId = data?.nodeId || data?.deviceId;
  return !eventId || eventId === (node.deviceId || node.sessionId || node.id);
};

export const pollingRuntime = (reported, current) => {
  const modules = reported.runtimeModules;
  if (reported.runtimeStatusAvailable === true && Array.isArray(modules) && modules.length) {
    return { runtimeModules: modules, runtimeStatusAvailable: true, runtimeStatusSource: 'api' };
  }
  if (current?.runtimeStatusAvailable === true && current.runtimeModules?.length) {
    return { runtimeModules: current.runtimeModules, runtimeStatusAvailable: true, runtimeStatusSource: current.runtimeStatusSource };
  }
  return { runtimeModules: Array.isArray(modules) ? modules : [], runtimeStatusAvailable: reported.runtimeStatusAvailable === true };
};

export const mergeNodeRefresh = (registry, sessions, removed) => {
  const merged = new Map(registry.map(node => [node.id, node]));
  for (const node of sessions.filter(Boolean)) merged.set(node.id, { ...merged.get(node.id), ...node });
  return [...merged.values()].filter(node => !removed.has(node.id));
};

// Only one poll runs at a time. Mutations invalidate its snapshot before it
// can commit; the next scheduled poll then starts with the new state.
export const createRefreshGate = () => {
  let revision = 0;
  let active = false;
  return {
    begin: () => { if (active) return null; active = true; return revision; },
    invalidate: () => { revision += 1; },
    isCurrent: token => token === revision,
    finish: () => { active = false; }
  };
};
